// Suggestion chips. Used both for the persona-provided options on the first
// turn and the on-demand "Suggest replies" panel.

import type { Suggestion } from '@/lib/types';

interface ReplyOptionsProps {
  options: Suggestion[];
  accent: string;
  onSelect: (option: Suggestion) => void;
}

export function ReplyOptions({ options, accent, onSelect }: ReplyOptionsProps) {
  if (options.length === 0) return null;
  return (
    <ul className="flex flex-wrap gap-2 px-4 pb-2 anim-slide-up" aria-label="Reply suggestions">
      {options.map((opt) => (
        <li key={opt.hz}>
          <button
            type="button"
            onClick={() => onSelect(opt)}
            className="px-3 py-2 rounded-full ff-zh-serif text-[14px] font-medium border-2"
            style={{ borderColor: accent, color: accent, background: 'white' }}
            aria-label={`${opt.hz} — ${opt.en}`}
          >
            <span>{opt.hz}</span>
            <span className="ff-body text-[10px] ml-1.5 opacity-60">{opt.py}</span>
          </button>
        </li>
      ))}
    </ul>
  );
}
